import type { RootState } from '@generalTypes/rootStateTypes';
import { selectCurrentEditingNode } from '@store/selectors/asideSelectors';
import { useSelector } from 'react-redux';

export const useCurrentEditNode = () => {
  return useSelector((state: RootState) => selectCurrentEditingNode(state));
};
